import { CostArgs } from '../../../../utils'
import { OntarioPurchaseTaxes } from '../purchase-taxes'

export const PurchaseTaxes = (args: CostArgs) =>
  ({
    ...OntarioPurchaseTaxes(args),
  } as const)
